module.exports = __webpack_public_path__ + "static/07b263e54eff3a2fa19b573af2370ec1.png";